import { ChangeDetectorRef, Component, OnInit, Input, OnDestroy, AfterViewInit, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { WebPlayer } from "@antmedia/web_player";
import { SignalingService } from '../../services/signaling.service';
import * as uuid from 'uuid';
@Component({
  selector: 'app-custom-video',
  templateUrl: './custom-video.component.html',
  styleUrls: ['./custom-video.component.scss']
})
export class CustomVideoComponent implements OnInit, OnDestroy, AfterViewInit {
  public iframe_html: SafeResourceUrl = undefined;
  public cameraType = undefined;
  public isRecording = false;
  public loading: boolean = true;
  // public heightLayer: string = '100%';

  private webRTCAdaptor: WebPlayer;
  // private resizeObserver!: ResizeObserver;
  public originalUrl: string = '';


  @Input() stream_type: string = 'url';
  @Input() _id: string = undefined;
  @Input() name: any = '';
  @Input() picture: any = '';
  @Input() rtspId = '';
  @Input() isSingle: boolean = false;
  @Input() muted: boolean = true;
  @Input() showLocateButton: boolean = false;
  @Input() buildingId: string = undefined;
  @Input() floorId: string = undefined;
  @Input() roomName: string = undefined;
  @Input() addCloseButton: boolean = false;
  @Output() closeButtonClicked = new EventEmitter<void>();

  @Input() showStopButton: boolean = false;
  @Output() locate = new EventEmitter<void>();
  public _value: any = undefined;
  private resolvedStreamId: string = '';
  private viewReady = false;
  /** DOM id for this tile only. A shared stream id collides with the cached Mission Control player. */
  private readonly playerDomId: string = 'video-player-' + uuid.v4();

  @Input()
  set value(value: any) {
    this._value = value;
    this.originalUrl = value;
    // console.log('value', value);
    if (value) {
      if (this.stream_type == 'rtmp/rtsp') {
        this.cameraType = 'civix-rtmp';
        if (this.rtspId) {
          this._value = this.buildCivixStreamUrl();
          this.prepareIframeUrl();
        }
      } else {
        const normalizedValue = typeof value === 'string' ? value.trim() : value;
        if (normalizedValue && (normalizedValue.startsWith('rtsp://') || normalizedValue.startsWith('rtmp://'))) {
          this.cameraType = 'rtsp';
          this.resolvedStreamId = this.rtspId || this.extractStreamIdFromUrl(normalizedValue);
          this.tryStartRtspCamera();
        } else if (normalizedValue && normalizedValue.indexOf('antmedia') > -1) {
          this.cameraType = 'antmedia';
          this._value = this._value + '&mute=' + this.muted;
          this.prepareIframeUrl();
        } else if (normalizedValue && normalizedValue.indexOf('vimeo.com') > -1) {
          this.cameraType = 'vimeo';
          this.prepareIframeUrl();
        } else if (normalizedValue && normalizedValue.indexOf('youtube.com') > -1) {
          this.cameraType = 'youtube';
          this._value = this._value + '&amp;controls=0&amp;autoplay=1&amp;mute=1&amp;disablekb=1&amp;rel=0&amp;loop=1&modestbranding=1';
          this.prepareIframeUrl();
        } else {
          this.cameraType = 'antmedia';
          this._value = this._value + '&mute=' + this.muted;
          this.prepareIframeUrl();
        }
      }
    } else {
      this.cameraType = 'empty';
    }
  }
  get value(): any {
    return this._value;
  }

  @ViewChild('rtspVideo', { static: false }) rtspVideo: ElementRef;

  constructor(private sanitizer: DomSanitizer, private signalingService: SignalingService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.tryStartRtspCamera();
  }

  /**
   * Drop this tile's player while the view is cached off screen.
   * Leaving the iframe or WebRTC element attached in a detached route keeps the
   * only viewer hidden, and the Cameras page cannot take the same feed.
   */
  releasePlayback(): void {
    this.destroyRtspPlayer();
    if (this.cameraType && this.cameraType !== 'rtsp' && this.cameraType !== 'empty') {
      // Remove the iframe now. This runs before the cached view detaches change
      // detection, and a later "same URL" assignment will not reload the player.
      this.iframe_html = undefined;
      this.changeDetectorRef.detectChanges();
    }
  }

  /** Restart playback after the tile was taken off screen and shown again. */
  refreshPlayback(): void {
    if (this.cameraType === 'rtsp') {
      this.tryStartRtspCamera();
      return;
    }
    if (!this._value || this.cameraType === 'empty') {
      return;
    }
    this.iframe_html = undefined;
    this.changeDetectorRef.detectChanges();
    this.prepareIframeUrl();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroyRtspPlayer();
  }

  private getActiveStreamId(): string {
    return this.resolvedStreamId || this.rtspId || '';
  }

  private extractStreamIdFromUrl(url: string): string {
    try {
      const parsed = new URL(url.trim());
      const segments = parsed.pathname.split('/').filter(Boolean);
      return segments.length ? segments[segments.length - 1] : '';
    } catch {
      return '';
    }
  }

  private tryStartRtspCamera(): void {
    if (!this.viewReady || this.cameraType !== 'rtsp' || !this.getActiveStreamId() || !this.rtspVideo?.nativeElement) {
      return;
    }
    this.destroyRtspPlayer();
    this.startRtspCamera();
  }

  private destroyRtspPlayer(): void {
    try {
      if (this.webRTCAdaptor) {
        if (this.webRTCAdaptor.tryNextTechTimer) {
          clearTimeout(this.webRTCAdaptor.tryNextTechTimer);
          this.webRTCAdaptor.tryNextTechTimer = undefined;
        }

        this.webRTCAdaptor.videojsPlayer?.pause();
        this.webRTCAdaptor.destroyVideoJSPlayer();
        if (this.webRTCAdaptor.videojsPlayer) {
          this.webRTCAdaptor.videojsPlayer.srcObject = null;
          this.webRTCAdaptor.videojsPlayer = undefined;
        }
        this.webRTCAdaptor.destroy();
        this.webRTCAdaptor = undefined;
        this.rtspVideo?.nativeElement?.querySelector('#' + this.playerDomId)?.remove();
      }
    } catch (e) { }
  }

  prepareIframeUrl() {
    if (this._value) {
      this.iframe_html = this.transform(this._value);
    } else {
      this.iframe_html = this.transform('/empty');
    }
  }

  transform(url) {
    if (this.sanitizer) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  private buildCivixStreamUrl(): string {
    return environment.streaming + '/play.html?id=' + this.rtspId + '&mute=' + (this.muted ? 'true' : 'false');
  }

  toggleCivixMute(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.muted = !this.muted;

    if (this.stream_type === 'rtmp/rtsp' && this.cameraType === 'civix-rtmp' && this.rtspId) {
      this._value = this.buildCivixStreamUrl();
      this.prepareIframeUrl();
    }
  }

  onLocateClick(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.locate.emit();
  }

  private startRtspCamera(): void {
    const streamId = this.getActiveStreamId();
    if (!streamId || !this.rtspVideo?.nativeElement) {
      return;
    }

    this.webRTCAdaptor = new WebPlayer({
      mediaConstraints: {
        video: true,
        audio: true,
      },
      controls: this.isSingle || false,
      streamId: streamId,
      httpBaseURL: environment.streaming,
      playOrder: ["webrtc", "hls"],
      mute: this.muted,
      videoPlayerId: this.playerDomId,
      videoHTMLContent: '<video id="' + this.playerDomId + '" class="video-js vjs-default-skin vjs-big-play-centered" controls playsinline style="width:100%;height:100%"></video>',
    }, this.rtspVideo.nativeElement, null);

    this.webRTCAdaptor.initialize().then(() => {
      try {
        this.webRTCAdaptor.play();
        // this.webRTCAdaptor.videojsPlayer.off('webrtc-error');
        // this.webRTCAdaptor.videojsPlayer.off('error');
      }
      catch (error) {
        console.error("Error playing stream: " + error);
      };
    }).catch((error) => {
      console.error("Error initializing player: " + error);
    });
  }

  // private setupResizeObserver(): void {
  //   const videoContainer = document.getElementById('rtsp_video_container');

  //   this.resizeObserver = new ResizeObserver(entries => {
  //     for (let entry of entries) {
  //       const width = entry.contentRect.width;

  //       const controlBar = videoContainer.querySelector('.vjs-control-bar') as HTMLElement;
  //       if (controlBar) {
  //         if (width < 200) {
  //           controlBar.classList.add('vjs-hidden');
  //         } else {
  //           controlBar.classList.remove('vjs-hidden');
  //         }
  //       }
  //     }
  //   });

  //   this.resizeObserver.observe(videoContainer);
  // }

  // private playStream(): void {
  //   // if (this.webRTCAdaptor && this.rtspId) {
  //   //   this.webRTCAdaptor.play();
  //   // }
  //   // else {
  //   this.startRtspCamera();
  //   // }
  // }

  // calculateVideoOnlyHeight(): void {
  //   const playerElement = document.getElementById('rtsp_video_container');
  //   const controlBar = playerElement.querySelector('.vjs-control-bar') as HTMLElement;

  //   const totalHeight = playerElement.getBoundingClientRect().height;
  //   const controlHeight = controlBar?.getBoundingClientRect().height || 0;
  //   const videoOnlyHeight = totalHeight - controlHeight;

  //   this.heightLayer = `${controlBar.offsetHeight}px`;
  //   console.log('Total player height:', totalHeight);
  //   console.log('Control bar height:', controlHeight);
  //   console.log('Video-only height:', videoOnlyHeight);
  // }

  // toggleRtspCamera(e) {
  //   if (e) {
  //     e.stopImmediatePropagation();
  //     e.preventDefault();
  //   }

  //   if (this.isRtspPlaying) {
  //     //stop
  //     this.loader.display(true);
  //     this.caseService.getCasesByCamera(this.name).then((res: any) => {
  //       if (res?.length) {
  //         const usedInList = res.map((item: any, i: number) => `• ${item.name}`).join('\n');
  //         const dialog = this.dialog.open(ConfirmEntityDialogComponent, {
  //           data: {
  //             // title: 'Warning',
  //             description: this.translate.instant('This camera is already in use by another case. Do you want to continue?') + `

  //             ${usedInList}`,
  //             cancelbtn: this.translate.instant('Cancel'),
  //             confirmbtn: this.translate.instant('Confirm'),
  //           },
  //           width: 'fit-content',
  //         });
  //         dialog.afterClosed().subscribe((result) => {
  //           if (result) {
  //             this.stopCamera();
  //           }
  //           else {
  //             this.loader.display(false);
  //           }
  //         });
  //       }
  //       else {
  //         this.stopCamera();
  //       }
  //       this.loader.display(false);
  //     });
  //   }
  //   else {
  //     //start
  //     this.loading = true;
  //     this.requestService.postRequest('camera', 'broadcast/start', { id: this.rtspId }, (data, error) => {
  //       if (data) {
  //         this.isRtspPlaying = data.results?.success;
  //         if (this.isRtspPlaying)
  //           this.playStream();
  //       }
  //       this.loading = false;
  //     });
  //   }
  // }

  // private stopCamera() {
  //   this.loading = true;
  //   this.requestService.postRequest('camera', 'broadcast/stop', { id: this.rtspId }, (data, error) => {
  //     if (data) {
  //       this.isRtspPlaying = !data.results?.success;
  //       if (!this.isRtspPlaying)
  //         this.webRTCAdaptor.destroy();
  //     }
  //     this.loading = false;
  //   });
  // }
  onStopStreamClick(event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.publishTabletCameraDisabledSignal();
  }

  private publishTabletCameraDisabledSignal(): void {
    const buildingId = String(this.buildingId || '').trim();
    const floorId = String(this.floorId || '').trim();
    const roomName = String(this.roomName || '').trim();
    const topicSuffix = !roomName
      ? 'cameras'
      : `${floorId}-${roomName.replaceAll(' ', '_')}`;
    // const roomName = String(this.roomName || '').trim();
    const tabletId = String(this.rtspId || '').trim();

    if (!buildingId) {
      return;
    }
    this.signalingService.publish('', {
      isEnabled: false,
      id: tabletId
    }, `${this.signalingService.indoorAlertsTopicName}-${buildingId}-${topicSuffix}`);
  }
}